"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuConfigHideLoneNode = exports.searchAndRestoreLoneNodes = exports.hiddeLoneNodes = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importDefault(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const SankeyUtils_1 = require("open-sankey/dist/SankeyUtils");
// Function that search and hide node that hvae 1 input link, 1 output link and have hideLoneNode at true
// To do so a link is created and start from the source of the input link to the target of the output link 
// finally we hide the node by putting it visibility to false
const hiddeLoneNodes = (data, getLinkValue) => {
    const displayed_product = Object.values(data.nodes).filter(n => {
        const is_to_hide = n.hide_lone_node;
        const is_intermediary_node_s = Object.values(n.inputLinksId).filter(l => {
            return SankeyUtils_1.link_visible(data.links[l], data, getLinkValue) && !data.links[l].recycling;
        }).length == 1;
        const is_intermediary_node_t = Object.values(n.outputLinksId).filter(l => {
            return SankeyUtils_1.link_visible(data.links[l], data, getLinkValue) && !data.links[l].recycling;
        }).length == 1;
        return n.display && is_to_hide && is_intermediary_node_s && is_intermediary_node_t;
    });
    displayed_product.map(n => {
        const src = Object.values(n.inputLinksId).filter(l => SankeyUtils_1.link_visible(data.links[l], data, getLinkValue))[0];
        const trgt = Object.values(n.outputLinksId).filter(l => SankeyUtils_1.link_visible(data.links[l], data, getLinkValue))[0];
        const n_l = JSON.parse(JSON.stringify(data.links[src]));
        n_l.idSource = data.links[src].idSource;
        n_l.idTarget = data.links[trgt].idTarget;
        n_l.idLink = 'linkTmp' + n.idNode + '-';
        const ind_in_src = data.nodes[data.links[src].idSource].outputLinksId.indexOf(src);
        const ind_in_trgt = data.nodes[data.links[trgt].idTarget].inputLinksId.indexOf(trgt);
        data.nodes[data.links[src].idSource].outputLinksId.splice(ind_in_src, 0, n_l.idLink);
        data.nodes[data.links[trgt].idTarget].inputLinksId.splice(ind_in_trgt, 0, n_l.idLink);
        data.links[n_l.idLink] = n_l;
        data.nodes[n.idNode].node_visible = false;
    });
};
exports.hiddeLoneNodes = hiddeLoneNodes;
//Function to restore hidden node when we deselect the hideLonNode property
const searchAndRestoreLoneNodes = (data) => {
    const link_tmp = Object.values(data.links).filter(l => l.idLink.includes('linkTmp'));
    Object.values(data.nodes).filter(n => n.display && !n.hide_lone_node).forEach(n => {
        link_tmp.filter(l => l.idLink.includes((n.idNode + '-'))).forEach(l => SankeyUtils_1.delete_link(data, l));
        //data.nodes[n.idNode].node_visible=true
    });
};
exports.searchAndRestoreLoneNodes = searchAndRestoreLoneNodes;
const MenuConfigHideLoneNode = (t, data, set_data, multi_selected_nodes) => {
    const isAllHideIfAlone = () => {
        let hide = false;
        multi_selected_nodes.current.map(d => hide = (d.hide_lone_node) ? true : hide);
        return hide;
    };
    return (react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Row },
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 7 },
            react_1.default.createElement(react_bootstrap_1.FormLabel, null, t('Noeud.apparence.HideAlone'))),
        react_1.default.createElement(react_bootstrap_1.Col, { xs: 1 },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: 'switch', checked: isAllHideIfAlone(), onChange: evt => {
                    Object.values(data.nodes).filter(f => multi_selected_nodes.current.map(d => d.idNode).includes(f.idNode)).map(d => d.hide_lone_node = evt.target.checked);
                    set_data(Object.assign({}, data));
                } }))));
};
exports.MenuConfigHideLoneNode = MenuConfigHideLoneNode;
